import { useState } from "react";
import classNames from "classnames";
import { toast } from "sonner";

import { fileApi } from "src/1/apis/file.api";

import { IconUpload } from "./Icons";

export const UploadZone = ({ append }) => {
  //#region Data
  const [uploading, setUploading] = useState(false);
  //#endregion

  //#region Event
  const onFilesChange = async (event) => {
    const filesList = event.target.files;
    if (!filesList || filesList.length === 0) return;
    setUploading(true);

    const files = Array.from(filesList);

    for (const file of files) {
      try {
        const res = await fileApi.upload(file);
        append(res.data.data);
      } catch (error) {
        toast.error(error?.message || "Lỗi không xác định khi xử lý file");
      }
    }

    event.target.value = "";
    setUploading(false);
  };
  //#endregion

  //#region Render
  return (
    <label
      className={classNames(
        "block",
        uploading ? "cursor-not-allowed" : "cursor-pointer",
      )}
    >
      <div
        className={classNames(
          "flex flex-col items-center justify-center rounded-xl border-2 border-dashed px-4 py-6 transition-all duration-300",
          uploading
            ? "border-indigo-300 bg-indigo-50/30"
            : "border-slate-200 bg-slate-50 hover:border-indigo-400 hover:bg-white",
        )}
      >
        {uploading ? (
          <div className="flex flex-col items-center gap-3">
            <div className="relative">
              <div className="translate-y-1/2">
                <div className="h-12 w-12 animate-spin rounded-full border-4 border-indigo-500/20 border-t-indigo-500"></div>
              </div>
              <div className="absolute inset-0 h-12 w-12 animate-pulse rounded-full border-4 border-transparent border-b-indigo-500/30"></div>
            </div>
            <div className="text-center">
              <span className="text-sm font-bold text-indigo-600">
                Đang xử lý file...
              </span>
              <p className="mt-1 text-[11px] font-medium text-slate-400 uppercase tracking-wider mb-0">
                Vui lòng không đóng trình duyệt
              </p>
            </div>
          </div>
        ) : (
          <>
            <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-sm ring-1 ring-slate-100">
              <IconUpload className="size-6 text-indigo-500" />
            </div>
            <span className="text-sm font-bold text-slate-700">
              Chọn để upload file
            </span>
            <span className="mt-1 text-xs font-medium text-slate-400">
              Hỗ trợ định dạng: .jpg, .png, .webp
            </span>
          </>
        )}
      </div>
      <input
        type="file"
        hidden
        multiple
        accept="image/jpeg,image/png,image/webp"
        onChange={onFilesChange}
        disabled={uploading}
      />
    </label>
  );
  //#endregion
};
